import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, Users, BarChart3, Tag, Trophy, IndianRupee, LifeBuoy } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";

const links = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true, id: "overview" },
  { to: "/admin/tests", label: "Tests & Questions", icon: FileText, id: "tests" },
  { to: "/admin/categories", label: "Categories", icon: Tag, id: "categories" },
  { to: "/admin/toppers", label: "Rankers", icon: Trophy, id: "toppers" },
  { to: "/admin/students", label: "Students", icon: Users, id: "students" },
  { to: "/admin/tickets", label: "Password Tickets", icon: LifeBuoy, id: "tickets" },
  { to: "/admin/payments", label: "Payments", icon: IndianRupee, id: "payments" },
  { to: "/admin/results", label: "Results", icon: BarChart3, id: "results" },
];

export const AdminLayout = () => (
  <div className="min-h-screen bg-[#F8FAFC]">
    <AppHeader />
    <div className="flex flex-col md:flex-row">
      <aside className="md:w-60 md:min-h-[calc(100vh-4rem)] border-b md:border-b-0 md:border-r border-slate-200 bg-white p-3 md:p-4">
        <div className="small-label px-3 mb-3 hidden md:block">Control Panel</div>
        <nav className="flex md:flex-col gap-1 overflow-x-auto">
          {links.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${id}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? "bg-[#EFF6FF] text-[#1D4ED8]" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 p-4 sm:p-8 min-w-0"><Outlet /></main>
    </div>
  </div>
);
